import type { JSX } from "react";

export function IconLoading(): JSX.Element {
    return <div className="spinner-border icon" role="status" />;
}
